module["exports"] = [
  "####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/postcode.js
// module id = 851
// module chunks = 0